import Vue from "vue";
var serverApiUrl = "";

if (process.env.NODE_ENV === "development") {
  // serverApiUrl="http://192.168.1.202:8083/suqianServer";
  // serverApiUrl="http://192.168.1.189:8015/suqianServer";
  // serverApiUrl="http://test.newgain.net:6443/suqianServer";
  serverApiUrl = "/suqianServer";
} else {
  console.log("生产环境");
  //   serverApiUrl = "https://ebdc.ssipac.suqian.gov.cn:8001/suqianServer";
  //   443
  serverApiUrl = "https://ebdc.ssipac.suqian.gov.cn/suqianServer";
}

export default {
  getServerUrl: function() {
    return serverApiUrl;
  },
  getAppVersion: function() {
    return appVersion;
  },
  GetRequest: function() {
    var url = decodeURI(location.search); //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },
  openInWebview: function() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 微信浏览器判断
      return false;
    } else if (ua.match(/QQ/i) == "qq") {
      // QQ浏览器判断
      return false;
    } else if (ua.match(/WeiBo/i) == "weibo") {
      return false;
    } else if (ua.match(/alipayclient/i) == "alipayclient") {
      //判断支付宝
      return false;
    } else if (ua.match(/ucbrowser/i) == "ucbrowser") {
      //判断uc
      return false;
    } else {
      if (ua.match(/Android/i) != null) {
        return ua.match(/browser/i) == null;
      } else if (ua.match(/iPhone/i) != null) {
        return ua.match(/safari/i) == null;
      } else {
        return ua.match(/macintosh/i) == null && ua.match(/windows/i) == null;
      }
    }
  },
  IsWeixinOrAlipay: function() {
    //判断是不是支付宝
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      // 微信浏览器判断
      return "weixin";
    } else if (ua.match(/alipayclient/i) == "alipayclient") {
      //判断支付宝
      return "alipay";
    }
    return "other";
  },
  isAndroidOrIos() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    var isXiaomi = u.indexOf("XiaoMi") > -1; // 小米手机
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 其它安卓
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios
    if (isAndroid) {
      return "android";
    } else if (isIOS) {
      // if(isXiaomi) {
      //   alert("您的浏览器标识为iPhone，请前往设置：“设置”->“高级设置”->“浏览器标识=默认”");
      // }else {
      //   alert("ios系统");
      // }
      return "ios";
    }
  },
  isIdCardNo: function(id) {
    console.log(id.substring(3, 14));
    if (id.substring(3, 14) == "***********") {
      return true;
    }
    // 身份证校验
    var num = id.toUpperCase();
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
      //alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
      return false;
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    //下面分别分析出生日期和校验位
    var len, re;
    len = num.length;
    if (len == 15) {
      re = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/i;
      var arrSplit = num.match(re);

      //检查生日日期是否正确
      var dtmBirth = new Date(
        "19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
      );
      var bGoodDay;
      bGoodDay =
        dtmBirth.getYear() == Number(arrSplit[2]) &&
        dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
        dtmBirth.getDate() == Number(arrSplit[4]);
      if (!bGoodDay) {
        //alert('输入的身份证号里出生日期不对！');
        return false;
      } else {
        //将15位身份证转成18位
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var arrCh = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
        var nTemp = 0,
          i;
        num = num.substr(0, 6) + "19" + num.substr(6, num.length - 6);
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i];
        }
        num += arrCh[nTemp % 11];
        return true;
      }
    }
    if (len == 18) {
      re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/i;
      var arrSplit = num.match(re);

      //检查生日日期是否正确
      var dtmBirth = new Date(
        arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
      );
      var bGoodDay;
      bGoodDay =
        dtmBirth.getFullYear() == Number(arrSplit[2]) &&
        dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
        dtmBirth.getDate() == Number(arrSplit[4]);
      if (!bGoodDay) {
        return false;
      } else {
        //检验18位身份证的校验码是否正确。
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var valnum;
        var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var arrCh = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
        var nTemp = 0,
          i;
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[nTemp % 11];
        if (valnum != num.substr(17, 1)) {
          return false;
        }
        return true;
      }
    }
    return false;
  },
  checknr: function(str) {
    let flag = true;
    let specialKey = "[`~!#$^&*()=|{}''\\[\\].<>/?~#￥……&*（）——|{}【】‘”“']‘'";
    for (var i = 0; i < str.length; i++) {
      if (specialKey.indexOf(str.substr(i, 1)) != -1) {
        flag = false;
        break;
      }
    }
    return flag;
  },
  isEmail(v) {
    var key = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    return key.test(v);
  }
};

/*import atabbar from "../../components/template/atabbar.vue"
const Atabbar= {
	install:function(Vue){
		Vue.component("atabbar",atabbar);
	}
}*/



// WEBPACK FOOTER //
// ./src/assets/js/app.js